import me from './eghosa.jpg'
import Button from './Button'

const About = () => {
  return (
    <div className="about">
        <img className="myImg" src={me} alt="Me" />
        <h2>
          I'm a <span className="typing">Frontend Developer</span>.
        </h2>
        <p>
          I help designers, entrepreneurs, and businesses bring their ideas to
          life.</p> 
        <p>
        Powered by VS Code, stack overflow and lots of sugar, I turn
        your requirements into simple and exceptional digital experiences - on
        time and on budget.
         </p>
        <Button name="Hire Me"/>
    </div>
  )
}

export default About